var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KeyValue',{attrs:{"caption":_vm.$t('Suppliers.OnSite'),"data-qa":"supplier-on-site","value":_vm.is_on_site}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }